
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gEFqRVNb9_zWpgPEhgHF7t5aNR2jhqe_Ir_fsNXJ5QmoMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUQSt0xtXYdZFRi7WipXvSJAyzXbTc98_E5dre7NwUagMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjBCPa4YtzRJG7tVKMQaGRfDL5Ja4Y5Ref1jcBNVwdwAMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1hUeuTj_IAidKn6SpjmbBuF4o3u4OcxQuq6Ly1EgBoIMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bQP1m9P3epYexSKeI87h_B8MQaO4D4XA0EWL__45iuKIMMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexMSuDQvXs0XL8i2ld2sVq_W1XwsHmlH0VK3pU7jQKko4Meta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93uwE_4537wZhUQWJJix21LZoRHTI3TTSuZyVTurPngbDaUMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexYwv1qw9y5bmQMUXDc5W75dBXO_txwAQstIisQAAggVQMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93US2awvbe5gVx7WXMi4VEZwcnpiT0svULV7OeY0he4JAMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexNQWhfPiH8iY86ZhEzYvx3XWi_45SoIQxaJVkLUKrbSSvsMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexK2A2RIr1LKTK5_45ffGl71mQdWTpO6Ht8NLEYA0GTluKcMeta } from "/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexMSuDQvXs0XL8i2ld2sVq_W1XwsHmlH0VK3pU7jQKko4Meta || {},
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexYwv1qw9y5bmQMUXDc5W75dBXO_txwAQstIisQAAggVQMeta || {},
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexNQWhfPiH8iY86ZhEzYvx3XWi_45SoIQxaJVkLUKrbSSvsMeta || {},
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexK2A2RIr1LKTK5_45ffGl71mQdWTpO6Ht8NLEYA0GTluKcMeta || {},
    component: () => import("/codebuild/output/src154692183/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]